import { isImefOrganization } from '../../../../../share/imef';

function imefInscriptionRules(userData = undefined) {
  if (!userData) return false;

  return ['PROSPECTO', 'APPROVED'].includes(userData?.validationStatus || null);
}

export function switchInscriptionPayment(userData, affiliationTypeLevel) {
  const isInscriptionActive =
    affiliationTypeLevel?.inscriptionConfig &&
    affiliationTypeLevel?.inscriptionConfig.active;

  if (isImefOrganization(userData?.headOffice?._id))
    return imefInscriptionRules(userData) && isInscriptionActive;

  return (
    isInscriptionActive
  );
  // &&
  //   !['INACTIVO'].includes(userData?.validationStatus || null)
}
